import { ReactNode } from "react";

import Filters from "components/Filters";
import FiltersContentWrapper from "components/Filters/ContentWrapper";
import FiltersMobileTriggerButton from "components/Filters/MobileTriggerButton";
import FiltersSidebar from "components/Filters/Sidebar";
import FiltersSplit from "components/Filters/Split";
import { FilterItem, FiltersItemsOptionsMap, SortOption } from "components/Filters/types";
import SearchInput from "components/SearchInput";
import ViewHeaderWrapper from "components/ViewHeader/Wrapper";
import Box from "ds/components/Box";
import PageInfoHeaderActions from "ds/components/PageInfoHeader/Actions";
import PageInfoHeaderTitle from "ds/components/PageInfoHeader/Title";
import PageInfoHeaderWrapper from "ds/components/PageInfoHeader/Wrapper";
import TooltipInfo from "ds/components/TooltipInfo";

import {
  MIGRATION_QUEUE_FILTERS_ORDER_SETTINGS_KEY,
  MIGRATION_QUEUE_FILTERS_TYPE,
  MIGRATION_QUEUE_FILTER_VARIABLES,
  MIGRATION_QUEUE_SUGGESTIONS_DICTIONARY,
} from "../constants";

type OpenTofuMigrationQueueFiltersLayoutProps = {
  children: ReactNode;
  isPageEmpty: boolean;
  filters: FilterItem[];
  filtersMap: FiltersItemsOptionsMap;
  sortOptions: SortOption[];
  filtersLoading: boolean;
};

const OpenTofuMigrationQueueFiltersLayout = ({
  children,
  isPageEmpty,
  filters,
  filtersMap,
  sortOptions,
  filtersLoading,
}: OpenTofuMigrationQueueFiltersLayoutProps) => (
  <>
    <PageInfoHeaderWrapper>
      <Box direction="row" align="center" gap="medium">
        <PageInfoHeaderTitle title="Queue" />
        <TooltipInfo variant="standard" widthMode="maxWidthSm">
          Every stack that was queued for migration to OpenTofu or for rollback to the Terraform
          vendor, and how it ended up.
        </TooltipInfo>
      </Box>

      {!isPageEmpty && (
        <PageInfoHeaderActions>
          <ViewHeaderWrapper direction="row" align="center">
            <SearchInput
              placeholder="Search by stack name or ID..."
              filtersOrderSettingsKey={MIGRATION_QUEUE_FILTERS_ORDER_SETTINGS_KEY}
            />
            <FiltersMobileTriggerButton />
          </ViewHeaderWrapper>
        </PageInfoHeaderActions>
      )}
    </PageInfoHeaderWrapper>

    <Filters
      filters={filters}
      filtersItemsOptionsMap={filtersMap}
      filtersLoading={filtersLoading}
      sortOptions={sortOptions}
      initialSortOption={MIGRATION_QUEUE_FILTER_VARIABLES.initialSortOption}
      initialSortDirection={MIGRATION_QUEUE_FILTER_VARIABLES.initialSortDirection}
      filtersOrderSettingsKey={MIGRATION_QUEUE_FILTERS_ORDER_SETTINGS_KEY}
      filtersType={MIGRATION_QUEUE_FILTERS_TYPE}
      filtersDictionary={MIGRATION_QUEUE_SUGGESTIONS_DICTIONARY}
      disableViews
    >
      <FiltersSplit>
        <FiltersSidebar />
        <FiltersContentWrapper>{children}</FiltersContentWrapper>
      </FiltersSplit>
    </Filters>
  </>
);

export default OpenTofuMigrationQueueFiltersLayout;
